import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function Insights() {
  return <section id="insights" className="py-20 lg:py-28 bg-white" data-id="element-270">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10" data-id="element-271">
        {/* Section Header */}
        <div className="reveal flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6" data-id="element-272">
          <div data-id="element-273">
            <span className="text-xs uppercase tracking-wider text-tlfc-gold font-medium" data-id="element-274">
              Insights
            </span>
            <h2 className="mt-4 font-serif text-3xl md:text-4xl text-tlfc-text" data-id="element-275">
              Legal insights that matter
            </h2>
            <p className="mt-3 text-tlfc-text-secondary text-lg" data-id="element-276">
              Practical updates from our team of specialists.
            </p>
          </div>
          <a href="#" className="inline-flex items-center gap-2 text-tlfc-gold font-medium hover:text-tlfc-gold-light transition-colors group" data-id="element-277">
            View all articles
            <ArrowRightIcon className="w-4 h-4 transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-278" />
          </a>
        </div>

        {/* Topic Filters */}
        <div className="reveal mt-8 flex flex-wrap gap-2" data-id="element-279">
          <button className="px-4 py-2 rounded-full text-sm font-medium bg-tlfc-text text-white" data-id="element-280">
            All
          </button>
          <button className="px-4 py-2 rounded-full text-sm font-medium border border-tlfc-border text-tlfc-text-secondary hover:border-tlfc-gold/40 hover:text-tlfc-text transition-colors" data-id="element-281">
            Property
          </button>
          <button className="px-4 py-2 rounded-full text-sm font-medium border border-tlfc-border text-tlfc-text-secondary hover:border-tlfc-gold/40 hover:text-tlfc-text transition-colors" data-id="element-282">
            Family
          </button>
          <button className="px-4 py-2 rounded-full text-sm font-medium border border-tlfc-border text-tlfc-text-secondary hover:border-tlfc-gold/40 hover:text-tlfc-text transition-colors" data-id="element-283">
            Business
          </button>
          <button className="px-4 py-2 rounded-full text-sm font-medium border border-tlfc-border text-tlfc-text-secondary hover:border-tlfc-gold/40 hover:text-tlfc-text transition-colors" data-id="element-284">
            Employment
          </button>
        </div>

        {/* Articles Grid */}
        <div className="reveal-stagger mt-10 grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-285">
          {/* Article 1 — Property */}
          <a href="#" className="group bg-tlfc-cream border border-tlfc-border rounded-xl overflow-hidden card-hover hover:border-tlfc-gold/40" data-id="element-286">
            <div className="relative aspect-[16/9] overflow-hidden" data-id="element-287">
              <img src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=600&q=80" alt="Modern house exterior representing property law" className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-288" />
              <div className="absolute inset-0 bg-gradient-to-t from-tlfc-dark/40 to-transparent" data-id="element-289" />
            </div>
            <div className="p-6" data-id="element-290">
              <span className="text-xs uppercase tracking-wider text-tlfc-gold font-medium" data-id="element-291">
                Property
              </span>
              <h3 className="mt-3 font-serif text-xl text-tlfc-text group-hover:text-tlfc-gold transition-colors leading-snug" data-id="element-292">
                Amendments to the Standard Contract of Sale in Victoria
              </h3>
              <p className="mt-3 text-sm text-tlfc-muted" data-id="element-293">
                By Jackson Byrnes · 3 March 2026
              </p>
            </div>
          </a>

          {/* Article 2 — Owners Corporations */}
          <a href="#" className="group bg-tlfc-cream border border-tlfc-border rounded-xl overflow-hidden card-hover hover:border-tlfc-gold/40" data-id="element-294">
            <div className="relative aspect-[16/9] overflow-hidden" data-id="element-295">
              <img src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600&q=80" alt="High-rise apartment building representing owners corporations" className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-296" />
              <div className="absolute inset-0 bg-gradient-to-t from-tlfc-dark/40 to-transparent" data-id="element-297" />
            </div>
            <div className="p-6" data-id="element-298">
              <span className="text-xs uppercase tracking-wider text-tlfc-gold font-medium" data-id="element-299">
                Owners Corporations
              </span>
              <h3 className="mt-3 font-serif text-xl text-tlfc-text group-hover:text-tlfc-gold transition-colors leading-snug" data-id="element-300">
                Restrictive Covenants, External Works and Who Really Has the
                Final Say
              </h3>
              <p className="mt-3 text-sm text-tlfc-muted" data-id="element-301">
                By Eve Whitmore · 17 February 2026
              </p>
            </div>
          </a>

          {/* Article 3 — Family Law */}
          <a href="#" className="group bg-tlfc-cream border border-tlfc-border rounded-xl overflow-hidden card-hover hover:border-tlfc-gold/40" data-id="element-302">
            <div className="relative aspect-[16/9] overflow-hidden" data-id="element-303">
              <img src="https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=600&q=80" alt="Family dog representing pets in family law" className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-304" />
              <div className="absolute inset-0 bg-gradient-to-t from-tlfc-dark/40 to-transparent" data-id="element-305" />
            </div>
            <div className="p-6" data-id="element-306">
              <span className="text-xs uppercase tracking-wider text-tlfc-gold font-medium" data-id="element-307">
                Family Law
              </span>
              <h3 className="mt-3 font-serif text-xl text-tlfc-text group-hover:text-tlfc-gold transition-colors leading-snug" data-id="element-308">
                Pets and Family Law: Who Gets the Dog When You Separate?
              </h3>
              <p className="mt-3 text-sm text-tlfc-muted" data-id="element-309">
                By Steven Edward · 3 February 2026
              </p>
            </div>
          </a>
        </div>
      </div>
    </section>;
}